/* eslint-disable react-hooks/exhaustive-deps */
import React from 'react';
import PropTypes from 'prop-types';
import _ from 'lodash';

import { withTranslation } from 'language/i18n';
import { getObjectByLanguage } from 'language/helpers';
import { Checkbox, Radio, Form } from 'components/common';
import types from 'constants/types';
import { BUYING_FORMAT, MACHINE_STATE } from 'constants/common';

const Filter = ({
  t, mobileVisible, setMobileVisible, filters, selectedFilters, onFilter, setFormRef,
}) => {
  const getFilterCheckedForRadio = (filter, defaultFilter) => {
    const checkedFilter = _.result(selectedFilters, filter);

    if (checkedFilter) {
      return checkedFilter[0];
    }

    return defaultFilter;
  };

  return (
    <div className="col-15 col-lg-3">
      <div className={`filter-menu ${mobileVisible && 'filter-menu--active'}`}>
        <div className="im-box im-box--white im-box--fluid im-box--border-radius im-box--padding-0 im-box--fluid d-flex flex-column im-box--max-height-on-small-screen">

          <Form
            layout="vertical"
            id="filterForm"
            className="h-100 w-100 d-flex flex-column overflow-auto"
            formRef={(ref) => setFormRef(ref)}
          >
            <div className="fs-17 fw-900 p-20">Filtreleme</div>
            <div className="separator separator--horizontal" />
            {/* <!-- Markalar --> */}
            <div className="filter">
              <div className="filter__title">{t('brands')}</div>
              <div className="filter__items">
                {
                  _.map(_.sortBy(filters.brand, ['selector']), (brand, index) => (
                    <div className="filter__item" key={index}>
                      <Checkbox
                        style={{ paddingBottom: 0 }}
                        name={`brands_${getObjectByLanguage(brand.selector)}`}
                        onChange={onFilter}
                        text={
                          <span className="im-checkbox__text">{`${getObjectByLanguage(brand.selector)} (${brand.count})`}</span>
                        }
                      />
                    </div>
                  ))
                }
              </div>
            </div>

            {/* <!-- Konum --> */}
            <div className="filter">
              <div className="filter__title">{t('location')}</div>
              <div className="filter__items">
                {
                  _.map(_.sortBy(filters.region, ['selector']), (location, index) => (
                    <div className="filter__item" key={index}>
                      <Checkbox
                        style={{ paddingBottom: 0 }}
                        name={`locations_${getObjectByLanguage(location.selector)}`}
                        onChange={onFilter}
                        text={
                          <span className="im-checkbox__text">{`${getObjectByLanguage(location.selector)} (${location.count})`}</span>
                        }
                      />
                    </div>
                  ))
                }
              </div>
            </div>

            {/* <!-- Satış Tipi --> */}
            <div className="filter">
              <div className="filter__title">{t('saleType')}</div>
              <div className="filter__items">
                <Radio
                  value={getFilterCheckedForRadio('format', '')}
                  groupStyle={{ flexDirection: 'column', display: 'flex' }}
                  onChange={onFilter}
                  name="format"
                  options={[
                    { value: '', label: <span className="im-checkbox__text">{t('all')}</span> },
                    // { value: BUYING_FORMAT.BID, label: <span className="im-checkbox__text">{t('auction')}</span> },
                    { value: BUYING_FORMAT.OFFER, label: <span className="im-checkbox__text">{t('makeOffer')}</span> },
                    { value: BUYING_FORMAT.BUY_NOW, label: <span className="im-checkbox__text">{t('buyNow')}</span> },
                  ]}
                  withoutFormItem
                />
              </div>
            </div>

            {/* <!-- Satış Durumu --> */}
            <div className="filter">
              <div className="filter__title">{t('salesStatus')}</div>
              <div className="filter__items">
                <Radio
                  value={getFilterCheckedForRadio('state', MACHINE_STATE.IN_EVENT)}
                  groupStyle={{ flexDirection: 'column', display: 'flex' }}
                  onChange={onFilter}
                  name="state"
                  options={
                    _.map(_.sortBy(filters.saleStates, ['selector']), (saleState) => {
                      return { value: saleState.selector, label: <span className="im-checkbox__text">{`${types[saleState.selector]} (${saleState.count})`}</span> };
                    })
                  }
                  withoutFormItem
                />
              </div>
            </div>
          </Form>
          {/* <!-- actions --> */}
          <div className="filter-menu__actions">
            <button type="submit" className="im-button im-button--primary im-button--fluid im-button--center" onClick={() => setMobileVisible(false)}>
              Uygula
            </button>
          </div>
        </div>
      </div>
      {/*  <!-- mobile filter close --> */}
      <i className="fa-solid fa-times mobile-menu-overflow-close" onClick={() => setMobileVisible(false)} />
    </div>
  );
};

Filter.propTypes = {
  t: PropTypes.func,
  setMobileVisible: PropTypes.func,
  mobileVisible: PropTypes.bool,
  filters: PropTypes.object,
  selectedFilters: PropTypes.object,
  onFilter: PropTypes.func,
  setFormRef: PropTypes.func,
};

export default withTranslation('common')(Filter);
